const initState = {
    error: null,
    portfolioList: [],
    response: null,
    type: '',
    currentGroup: null,
    currentProduct: null,
    currentPortfolio: null,
}

const portfolioReducer = (state = initState, action) => {

    switch (action.type) {

        case "PORTFOLIO_RESET": {
            return {
                ...state,
                portfolioList: [],
                currentPortfolio: null,
                currentProduct: null,
                currentGroup: null,
                error: null,
                response: null,
                type: action.type
            }
        }
        case "SET_CURRENT_PORTFOLIO": return { ...state, currentPortfolio: action.payload }
        case "SET_CURRENT_GROUP": return { ...state, currentGroup: action.payload }
        case "SET_CURRENT_PRODUCT": return { ...state, currentProduct: action.payload }

        case 'PORTFOLIO_LIST_PENDING': return { ...state, type: action.type, error: null }
        case 'PORTFOLIO_LIST_SUCCESS': return { ...state, type: action.type, error: null, portfolioList: action.payload }
        case 'PORTFOLIO_LIST_ERROR': return { ...state, type: action.type, error: action.payload, portfolioList: [] }

        case 'PORTFOLIO_SELECT_PENDING': return { ...state, type: action.type, error: null }
        case 'PORTFOLIO_SELECT_SUCCESS': return { ...state, type: action.type, error: null, currentPortfolio: action.payload }
        case 'PORTFOLIO_SELECT_ERROR': return { ...state, type: action.type, error: action.payload }

        case 'PORTFOLIO_CREATE_PENDING': return { ...state, type: action.type, error: null }
        case 'PORTFOLIO_CREATE_SUCCESS': return { ...state, type: action.type, error: null, response: action.payload }
        case 'PORTFOLIO_CREATE_ERROR': return { ...state, type: action.type, error: action.payload }

        case 'PORTFOLIO_UPDATE_PENDING': return { ...state, type: action.type, error: null }
        case 'PORTFOLIO_UPDATE_SUCCESS': return { ...state, type: action.type, error: null, response: action.payload }
        case 'PORTFOLIO_UPDATE_ERROR': return { ...state, type: action.type, error: action.payload }

        case 'PORTFOLIO_DELETE_PENDING': return { ...state, type: action.type, error: null }
        case 'PORTFOLIO_DELETE_SUCCESS': return { ...state, type: action.type, error: null, response: action.payload }
        case 'PORTFOLIO_DELETE_ERROR': return { ...state, type: action.type, error: action.payload }

        case 'PORTFOLIO_GENERATE_PENDING': return { ...state, type: action.type, error: null }
        case 'PORTFOLIO_GENERATE_SUCCESS': return { ...state, type: action.type, error: null, response: action.payload }
        case 'PORTFOLIO_GENERATE_ERROR': return { ...state, type: action.type, error: action.payload }

        default: return state;
    }
};

export default portfolioReducer;